import { render, staticRenderFns } from "./PoolBottomBar.vue?vue&type=template&id=a23abaf6&scoped=true&"
import script from "./PoolBottomBar.vue?vue&type=script&lang=js&"
export * from "./PoolBottomBar.vue?vue&type=script&lang=js&"
import style0 from "./PoolBottomBar.vue?vue&type=style&index=0&id=a23abaf6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a23abaf6",
  null
  
)

export default component.exports